
export const prototypeName = 'Dsr.SeebadDe:Composite.FaqList.Item';